/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'DASHBOARD',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'landing.dashboard',
                title: 'Gaia Club',
                type: 'basic',
                icon: 'heroicons_outline:chart-pie',
                link: '/dashboards/summary',
            }
        ],
    },
    {
        id: 'gestion',
        title: 'GESTIÓN',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'gestion.clientes',
                title: 'Clientes',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/apps/customers',
            },
            {
                id: 'gestion.compras',
                title: 'Compras/Órdenes',
                type: 'basic',
                icon: 'heroicons_outline:shopping-bag',
                link: '/apps/purchasing',
            },
            {
                id: 'gestion.recompensas',
                title: 'Recompensas',
                type: 'collapsable',
                icon: 'heroicons_outline:shopping-bag',
                children: [
                    {
                        id: 'gestion.recompensas.catalogo',
                        title: 'Catálogo de Recompensas',
                        type: 'basic',
                        icon: 'heroicons_outline:gift',
                        link: '/apps/rewards',
                    },
                    {
                        id: 'gestion.recompensas.procesar',
                        title: 'Procesar Canjes',
                        type: 'basic',
                        icon: 'heroicons_outline:shopping-cart',
                        link: '/apps/rewards/canjes-procesar',
                    },
                    {
                        id: 'gestion.recompensas.historial',
                        title: 'Historial de Canjes',
                        type: 'basic',
                        icon: 'heroicons_outline:queue-list',
                        link: '/apps/rewards/canjes-history',
                    },
                ],
            },            
        ]
    },
    {
        id: 'divider-2',
        type: 'divider',
    },
    {
        id: 'administracion',
        title: 'ADMINISTRACIÓN',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'administracion.bonificaciones',
                title: 'Bonificaciones',
                type: 'basic',
                icon: 'heroicons_outline:shield-check',
                link: '/apps/bonuses',
            },
            {
                id: 'administracion.periodos',
                title: 'Periodos',
                type: 'basic',
                icon: 'heroicons_outline:calendar',
                link: '/apps/periods',
            },
        ]
    },
    {
        id: 'reportes',
        title: 'REPORTES',
        type: 'group',
        icon: 'heroicons_outline:home',
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
